import * as React from 'react'
import styled from 'styled-components'
// import * as DateFns from 'date-fns'
import * as d3 from 'd3'
import { Icon } from '../../atoms/icon'
import { Color, Size } from '../../../constants/app.constant'
import useGetState from '../../../hooks/use-get-state'
// import { dispAge, calcAge, getWeekCount } from '../report/utils'
import { dispAge, calcAge } from '../report/utils'
import { StatusIcon } from '../../molecules/status-icon'
import {
  ResistanceLog,
  evaluationHashes,
} from '../../../interfaces/resistance-log'
import * as moment from 'moment'

const { useState, useEffect } = React
export default () => {
  // const getRandomInt = (max: number) => Math.floor(Math.random() * Math.floor(max))
  // const getRanHeartRates = () => Array(1800).fill(0).map(v => getRandomInt(250))
  const {
    state: {
      patient,
      report: { details },
    },
  } = useGetState()
  const [node, setNode] = useState<SVGSVGElement>()
  let defaultWidth = 300
  const defaultHeight = 250
  useEffect(
    () => {
      if (node && details) {
        const windowWidth = window.outerWidth
        if (windowWidth < 750) {
          defaultWidth = windowWidth - 20
        } else {
          defaultWidth = 730
        }
        // console.log(details.aerobicLog.heartRateLogs.map(v => v.heartRates).flat())
        // console.log(getRanHeartRates())
        const rates = details.aerobicLog.heartRateLogs
          .map(v => v.heartRates)
          .flat()
        const svg = d3.select(node)
        svg.attr('width', defaultWidth).attr('height', defaultHeight)
        const xScale = d3
          .scaleTime()
          .domain([0, 500])
          .range([10, defaultWidth])
        const yScale = d3
          .scaleLinear()
          .domain([1, 250])
          .range([defaultHeight - 10, 10])
        const line: any = d3
          .line()
          .x((d, i) => xScale(i))
          .y((d: any, i) => yScale(d))
        line.curve(d3.curveCatmullRom.alpha(0.4))
        const group = svg
          .selectAll('g')
          .data(rates)
          .enter()
          .append('g')
        group
          .append('circle')
          .attr('cx', (d, i) => xScale(i))
          .attr('cy', (d: any, i) => yScale(d))
          .attr('fill', Color.STATUS_BORDER)
          .attr('r', 4)
          .on('mouseover', (d, i) => {
            d3.select('.c-tooltip-' + i).attr('style', 'visibility: visible;')
          })
          .on('mouseout', (d, i) => {
            d3.select('.c-tooltip-' + i).attr('style', 'visibility: hidden;')
          })
        group
          .append('text')
          .attr('dx', (d, i) => xScale(i))
          .attr('dy', (d: any, i) => yScale(d) - 10)
          .attr('class', (d, i) => 'c-tooltip c-tooltip-' + i)
          .text((d: any) => d)
          .attr('fill', Color.LIGHT_GRAY)
        svg
          .append('path')
          .datum(rates)
          .attr('d', line)
          .attr('stroke', Color.LIGHT_GRAY)
          .attr('fill', 'none')
      }
    },
    [node]
  )
  return (
    <Wrapper>
      <PageContents>
        {details && (
          <>
            <UserDetail>
              <Icon.User size={`${Size.XLARGE}px`} color={Color.DARK_GRAY} />
              <UserName>
                {patient.username}
                さん
              </UserName>
              <Age>{dispAge(calcAge(patient.birthdayYmd))}</Age>
              <DetailEvaluationIconWrapper>
                <StatusIcon evaluation={Number(details.evaluation)} />
              </DetailEvaluationIconWrapper>
            </UserDetail>
            <TrainingDateWrapper>
              <TrainingCountWrapper>
                {/* <Week>{getWeekCount(new Date(details.finishedAt))}</Week> */}
                <Week>{details.finishedAt ? moment(details.finishedAt).add(+9, 'h').format('MM月DD日 HH:mm') + '終了' : '実施中'}</Week>
              </TrainingCountWrapper>
              <TrainingDate>
                {moment(details.startedAt).add(+9, 'h').format('MM月DD日 HH:mm') + '開始'}
              </TrainingDate>
            </TrainingDateWrapper>
            <TrainigItemWrapper>
              {details.patientDayTrainingResistanceLogs.map(
                (v: ResistanceLog, index: number) => (
                  <TrainigItem key={index}>
                    <TrainigItemLeft>
                      <Icon.Muscle
                        size={`${Size.LARGE}px`}
                        color={Color.DARK_GRAY}
                      />
                    </TrainigItemLeft>
                    <TrainigItemRight>
                      <TrainingName>
                        <StatusIcon evaluation={Number(v.evaluation)} />
                        <TrainingNameInner>{v.name}</TrainingNameInner>
                      </TrainingName>
                      <StatusMsg>
                        {evaluationHashes[Number(v.evaluation)]}
                      </StatusMsg>
                    </TrainigItemRight>
                  </TrainigItem>
                )
              )}
              <TrainigItem>
                <TrainigItemLeft>
                  <Icon.HeartRate
                    size={`${Size.LARGE}px`}
                    color={Color.DARK_GRAY}
                  />
                </TrainigItemLeft>
                <TrainigItemRight>
                  <TrainingName>
                    <StatusIcon
                      evaluation={Number(details.aerobicLog.evaluation)}
                    />
                    <TrainingNameInner>
                      {details.aerobicLog.name}
                    </TrainingNameInner>
                  </TrainingName>
                  <StatusMsg>
                    {evaluationHashes[Number(details.aerobicLog.evaluation)]}
                  </StatusMsg>
                </TrainigItemRight>
              </TrainigItem>
            </TrainigItemWrapper>
            <TrainingGraphWrapper>
              <GraphLabel>心拍数推移</GraphLabel>
              <GraphContents>
                <svg ref={node => setNode(node)} />
              </GraphContents>
            </TrainingGraphWrapper>
          </>
        )}
      </PageContents>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const PageContents = styled.div``
const UserDetail = styled.div`
  position: relative;
  margin: 8px;
  display: flex;
  align-items: center;
`
const DetailEvaluationIconWrapper = styled.div`
  position: absolute;
  right: 0;
`
const UserName = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 12px;
  margin-right: 16px;
`
const Age = styled.div`
  font-size: ${Size.BASE}px;
`
const TrainingDateWrapper = styled.div`
  margin: 8px;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 8px;
`
const TrainingDate = styled.div`
  font-size: ${Size.XLARGE}px;
  color: ${Color.BLACK};
  font-weight: ${Size.FONT_WEIGHT.THIN};
`
const Week = styled.div`
  color: ${Color.VERY_LIGHT_GRAY};
`
const TrainigItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
`
const TrainingCountWrapper = styled.div`
  font-size: ${Size.BASE}px;
  color: ${Color.VERY_LIGHT_GRAY};
  font-weight: ${Size.FONT_WEIGHT.NORMAL};
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
`
const TrainigItem = styled.div`
  display: flex;
  margin-bottom: 16px;
`
const TrainigItemLeft = styled.div`
  margin-right: 8px;
`
const TrainigItemRight = styled.div``
const TrainingName = styled.div`
  display: flex;
  align-items: normal;
`
const TrainingNameInner = styled.div`
  margin-left: 4px;
`
const StatusMsg = styled.div`
  font-size: ${Size.BASE}px;
  margin-top: 4px;
`
const TrainingGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
`
const GraphContents = styled.div`
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  overflow-x: scroll;
  .c-tooltip {
    font-size: ${Size.BASE}px;
    visibility: hidden;
  }
`
const GraphLabel = styled.div`
  font-size: ${Size.BASE}px;
  margin-bottom: 8px;
  font-weight: ${Size.FONT_WEIGHT.NORMAL};
`



// WEBPACK FOOTER //
// ./src/components/pages/report_detail/contents.tsx